var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { connect } from 'react-redux';
import LocationWidget from 'nucleus-widgets/lib/Location/LocationWidget';
import { getCountryName } from 'event-widgets/redux/selectors/countryName';
/**
 * Data wrapper for the event location widget.
 */
export default connect(function (state) {
    var translate = state.text.translate;
    var countryName = getCountryName(state, translate);
    var addressWithCountryName = __assign(__assign({}, state.event.address), { countryName: countryName });
    return {
        location: translate(state.event.location),
        address: addressWithCountryName
    };
})(LocationWidget);
